<a class="skip" (click)="focusHeader($event)" href="#">Fortsæt til indhold</a>
@if (!noContent) {
  <mat-sidenav-container>
    @let basketOpen = basketOpen$ | async;
    <mat-sidenav [opened]="basketOpen" mode="over" position="end" (closedStart)="basketService.setOverlay(false)">
      <app-basket></app-basket>
    </mat-sidenav>

    @let mobileMenuOpen = mobileMenuOpen$ | async;
    <mat-sidenav [opened]="mobileMenuOpen" mode="over" position="start" (closedStart)="mobileService.setOverlay(false)">
      @if (mobileService.loaded) {
        <app-mobile-menu [open]="mobileMenuOpen"></app-mobile-menu>
      }
    </mat-sidenav>

    @if (address && !isOnline) {
      <app-address-bar aria-hidden="true">{{ address }}</app-address-bar>
    }
    @if (isDagrofa) {
      <app-meny-header [showShipping]="showShipping" [showBasket]="showBasket"></app-meny-header>
      @if (showNavigation) {
        <app-meny-navigation [showShipping]="showShipping"></app-meny-navigation>
      }
    }
    @if (isOnline) {
      <app-online-header>{{ address }}</app-online-header>
    }

    @if (!isDagrofa && !isOnline) {
      @if (!showNavigationHeader) {
        <app-header [showShipping]="showShipping" [showBasket]="showBasket" [showInfoBar]="navigationHeader"></app-header>
        @if (showNavigation) {
          <app-navigation [showFilter]="showFilter"></app-navigation>
        }
      } @else {
        <app-navigation-header></app-navigation-header>
      }
    }

    @defer (hydrate on idle) {
      <app-streamer-banner></app-streamer-banner>
    }

    <main class="content-body" [class.content-body-shadow]="searchOpen$ | async">
      <router-outlet></router-outlet>
    </main>

    @defer (hydrate on idle) {
      @if (showFooter) {
        <app-footer></app-footer>
      }
    }
  </mat-sidenav-container>
}
@if (kioskService.blackout) {
  <div class="blackout-box"></div>
}
